<template>
    <v-btn
        v-scroll="onScroll"
        v-show="fab"
        fab
        dark
        fixed
        bottom
        right
        color="primary"
        @click="toTop"
    >
        <v-icon>mdi-chevron-double-up</v-icon>
    </v-btn>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
    data: () => ({
        fab: false,
    }),
    methods: {
        onScroll(e) {
            if (typeof window === "undefined") return;
            const top = window.pageYOffset || e.target.scrollTop || 0;
            this.fab = top > 20;
        },
        toTop() {
            window.scrollTo(0, 0);
        },
    },
});
</script>

<style scoped lang="sass">
@media print
    .v-btn
        display: none
</style>
